// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CarouselControls__button-wrapper-d15fcf {
  align-items: center;
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  pointer-events: none;
}

.CarouselControls__button-wrapper-d15fcf.CarouselControls__prev-e16d53 {
  inset-inline-start: var(--prev-button-wrapper-left);
  justify-content: flex-start;
}

.CarouselControls__button-wrapper-d15fcf.CarouselControls__next-a36f1f {
  inset-inline-end: var(--next-button-wrapper-right);
  justify-content: flex-end;
}

.CarouselControls__button-wrapper-d15fcf.CarouselControls__prev-e16d53.CarouselControls__with-shadow-de24b5 {
  background: linear-gradient(90deg, var(--base-10) 0%, var(--base-10_70) 65.08%, var(--base-10_00) 100%);
  width: 80px;
}

:root[dir=rtl] .CarouselControls__button-wrapper-d15fcf.CarouselControls__prev-e16d53.CarouselControls__with-shadow-de24b5 {
  background: linear-gradient(90deg, var(--base-10_00) 0%, var(--base-10_70) 65%, var(--base-10) 100%);
}

.CarouselControls__button-wrapper-d15fcf.CarouselControls__next-a36f1f.CarouselControls__with-shadow-de24b5 {
  background: linear-gradient(90deg, var(--base-10_00) 0%, var(--base-10_70) 65%, var(--base-10) 100%);
  width: 80px;
}

:root[dir=rtl] .CarouselControls__button-wrapper-d15fcf.CarouselControls__next-a36f1f.CarouselControls__with-shadow-de24b5 {
  background: linear-gradient(90deg, var(--base-10_00) 0%, var(--base-10_70) 65%, var(--base-10) 100%);
}

.CarouselControls__button-bcc713 {
  pointer-events: auto;
}

.CarouselControls__button-bcc713.CarouselControls__prev-e16d53 {
  transform: var(--prev-button-transform);
}

.CarouselControls__button-bcc713.CarouselControls__next-a36f1f {
  transform: var(--next-button-transform);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Carousel/CarouselControls/CarouselControls.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,mDAAA;EACA,2BAAA;AACF;;AAEA;EACE,kDAAA;EACA,yBAAA;AACF;;AAEA;EACE,uGAAA;EAMA,WAAA;AAJF;;AAOA;EACE,oGAAA;AAJF;;AAWA;EACE,oGAAA;EAMA,WAAA;AAbF;;AAgBA;EACE,oGAAA;AAbF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,uCAAA;AAjBF;;AAoBA;EACE,uCAAA;AAjBF","sourcesContent":[".button-wrapper {\n  align-items: center;\n  display: flex;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  pointer-events: none;\n}\n\n.button-wrapper.prev {\n  inset-inline-start: var(--prev-button-wrapper-left);\n  justify-content: flex-start;\n}\n\n.button-wrapper.next {\n  inset-inline-end: var(--next-button-wrapper-right);\n  justify-content: flex-end;\n}\n\n.button-wrapper.prev.with-shadow {\n  background: linear-gradient(\n    90deg,\n    var(--base-10) 0%,\n    var(--base-10_70) 65.08%,\n    var(--base-10_00) 100%\n  );\n  width: 80px;\n}\n\n:root[dir='rtl'] .button-wrapper.prev.with-shadow {\n  background: linear-gradient(\n    90deg,\n    var(--base-10_00) 0%,\n    var(--base-10_70) 65%,\n    var(--base-10) 100%);\n}\n\n.button-wrapper.next.with-shadow {\n  background: linear-gradient(\n    90deg,\n    var(--base-10_00) 0%,\n    var(--base-10_70) 65%,\n    var(--base-10) 100%\n  );\n  width: 80px;\n}\n\n:root[dir='rtl'] .button-wrapper.next.with-shadow {\n  background: linear-gradient(\n    90deg,\n    var(--base-10_00) 0%,\n    var(--base-10_70) 65%,\n    var(--base-10) 100%);\n}\n\n.button {\n  pointer-events: auto;\n}\n\n.button.prev {\n  transform: var(--prev-button-transform);\n}\n\n.button.next {\n  transform: var(--next-button-transform);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-wrapper": `CarouselControls__button-wrapper-d15fcf`,
	"buttonWrapper": `CarouselControls__button-wrapper-d15fcf`,
	"prev": `CarouselControls__prev-e16d53`,
	"next": `CarouselControls__next-a36f1f`,
	"with-shadow": `CarouselControls__with-shadow-de24b5`,
	"withShadow": `CarouselControls__with-shadow-de24b5`,
	"button": `CarouselControls__button-bcc713`
};
module.exports = ___CSS_LOADER_EXPORT___;
